var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "col float-right" },
        [
          _c(
            "q-btn-group",
            { attrs: { outline: "" } },
            [
              _c("c-update-btn", {
                attrs: {
                  name: "updateBtn",
                  data: _vm.param.updateBtnProps.data,
                  btnEditable: _vm.param.updateBtnProps.btnEditable,
                  flagCondition: _vm.param.updateBtnProps.flagCondition,
                },
              }),
              _c("c-btn", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.tabParam.accidentStatusCd === "ISPC000001" &&
                      !_vm.disabled &&
                      !_vm.param.isApprovePop,
                    expression:
                      "tabParam.accidentStatusCd === 'ISPC000001' && !disabled && !param.isApprovePop",
                  },
                ],
                attrs: {
                  editable: _vm.editable,
                  label: "삭제",
                  icon: "delete_forever",
                },
                on: { btnClicked: _vm.remove },
              }),
              _c("c-btn", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.tabParam.accidentStatusCd === "ISPC000001" &&
                      !_vm.disabled,
                    expression:
                      "tabParam.accidentStatusCd === 'ISPC000001' && !disabled",
                  },
                ],
                attrs: {
                  isSubmit: _vm.isComplete,
                  url: _vm.completeUrl,
                  param: _vm.tabParam,
                  mappingType: _vm.completeType,
                  label: "등록완료",
                  icon: "check",
                },
                on: {
                  beforeAction: _vm.completeAccident,
                  btnCallback: _vm.completeCallback,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("c-tab", {
        attrs: {
          type: "vertical",
          tabItems: _vm.tabItems,
          height: _vm.tabHeight,
        },
        on: {
          "update:height": function ($event) {
            _vm.tabHeight = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  tag: "component",
                  attrs: {
                    popupParam: _vm.param,
                    tabParam: _vm.tabParam,
                    contentHeight: _vm.contentHeight,
                  },
                  on: {
                    "update:popupParam": function ($event) {
                      _vm.param = $event
                    },
                    "update:popup-param": function ($event) {
                      _vm.param = $event
                    },
                    transInfo: _vm.transInfo,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }